<script>

import FundraiserLayoutModern from '@/pages/fundraisers/public/layouts/fundraiser/FundraiserLayoutModern.vue'
import FundraiserLayoutWidget from '@/pages/fundraisers/public/layouts/fundraiser/FundraiserLayoutWidget.vue'
import FundraiserLayoutClassic from '@/pages/fundraisers/public/layouts/fundraiser/FundraiserLayoutClassic.vue'
import fundraiserPublicFetchMixin from '@/mixins/fundraiserPublicFetchMixin.js'
export default {
  name: 'FundraiserPublicPage',
  components: { FundraiserLayoutModern, FundraiserLayoutClassic, FundraiserLayoutWidget },
  mixins:[fundraiserPublicFetchMixin]
}
</script>

<template>
  <component :is="layout" v-if="fundraiserId" :fundraiser-id="fundraiserId" />
</template>

<style scoped>

</style>
